import {CanActivateFn, Router, UrlTree} from "@angular/router";
import {catchError, map, Observable, of} from "rxjs";
import {AuthService} from "../../core/service/auth.service";
import {inject} from "@angular/core";

export const rootAreaGuardFn: CanActivateFn = (): Observable<UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const errorRoute = router.createUrlTree(['/error']);

  return authService.getRootAreaRoute().pipe(
    map(routeCommands => routeCommands.length ? router.createUrlTree(routeCommands) : errorRoute),
    catchError(() => of(errorRoute))
  );
};
